/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_ParentInputs */

const en_cmd_parent = /** @type {(inputs: Cmd_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set parent`)
};

const de_cmd_parent = /** @type {(inputs: Cmd_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordneten Vorgang setzen`)
};

/**
* | output |
* | --- |
* | "Set parent" |
*
* @param {Cmd_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_parent = /** @type {((inputs?: Cmd_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_parent(inputs)
	return en_cmd_parent(inputs)
});